module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table1"
  }, [_c('i', {
    staticClass: "el-icon-refresh-left"
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-1：基本情况表")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getcode201HistoryData
    }
  }, [_vm._v("导入历史数据")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            单位名称：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.params.publishName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishName", $$v)
      },
      expression: "params.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "usccNum",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入工商营业执照上“统一社会信用代码”项"
    },
    model: {
      value: (_vm.params.usccNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccNum", $$v)
      },
      expression: "params.usccNum"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "usccType",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择营业执照上“类型”项"
    },
    model: {
      value: (_vm.params.usccType),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccType", $$v)
      },
      expression: "params.usccType"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("住所：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "residence",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入工商营业执照上“住所”项"
    },
    model: {
      value: (_vm.params.residence),
      callback: function($$v) {
        _vm.$set(_vm.params, "residence", $$v)
      },
      expression: "params.residence"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "faren",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入工商营业执照上“法定代表人”项"
    },
    model: {
      value: (_vm.params.faren),
      callback: function($$v) {
        _vm.$set(_vm.params, "faren", $$v)
      },
      expression: "params.faren"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v(" 注册资本或开办资金（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yyzzZczb",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.yyzzZczb),
      callback: function($$v) {
        _vm.$set(_vm.params, "yyzzZczb", $$v)
      },
      expression: "params.yyzzZczb"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("成立日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "clDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(1)
      }
    },
    model: {
      value: (_vm.params.clDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "clDate", $$v)
      },
      expression: "params.clDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营业日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "startYyDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(2)
      }
    },
    model: {
      value: (_vm.params.startYyDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "startYyDate", $$v)
      },
      expression: "params.startYyDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midSpan"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(3)
      }
    },
    model: {
      value: (_vm.params.endYyDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "endYyDate", $$v)
      },
      expression: "params.endYyDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("注：营业执照有效期为长期的，无须填写结束日期")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("经营范围或业务范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yyfw",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入工商营业执照上“经营范围”项",
      "size": "small"
    },
    model: {
      value: (_vm.params.yyfw),
      callback: function($$v) {
        _vm.$set(_vm.params, "yyfw", $$v)
      },
      expression: "params.yyfw"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("登记日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "djDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(4)
      }
    },
    model: {
      value: (_vm.params.djDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "djDate", $$v)
      },
      expression: "params.djDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("证照编号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入工商营业执照上“证照编号”项",
      "size": "small"
    },
    model: {
      value: (_vm.params.usccCode),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccCode", $$v)
      },
      expression: "params.usccCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("没有请填写“无”")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("上传营业执照或事业法人证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "line-height": "24px"
    }
  }, [_vm._v("注：图片上传时要注意图片是否全部旋转到正确的方向，不得出现竖版图片横放的情况。点击图片大图模式下可以调整方向。\n              "), _c('br'), _vm._v("\n              上传文件格式为JPEG/PNG，文件大小不超过10M。\n            ")]), _vm._v(" "), _c('Upbtn', {
    attrs: {
      "ableSure": _vm.imgId,
      "needTip": "no"
    },
    on: {
      "upFileId": _vm.fileTdSet
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("单位基本信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("企业性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "nature",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择企业性质"
    },
    model: {
      value: (_vm.params.nature),
      callback: function($$v) {
        _vm.$set(_vm.params, "nature", $$v)
      },
      expression: "params.nature"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.CompanyNatureMap[_vm.params.nature] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "otherNature",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "若企业性质为“其他”，请输入"
    },
    model: {
      value: (_vm.params.otherNature),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherNature", $$v)
      },
      expression: "params.otherNature"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否为独立法人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isIndependentLP",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.layChange
    },
    model: {
      value: (_vm.params.isIndependentLP),
      callback: function($$v) {
        _vm.$set(_vm.params, "isIndependentLP", $$v)
      },
      expression: "params.isIndependentLP"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "tip-red"
  }, [_vm._v("以音像电子业务为主体业务的独立法人单位填写\"是\"，其他单位填写\"否\"")])], 1)]), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人单位类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "unitType",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择单位类型"
    },
    model: {
      value: (_vm.params.unitType),
      callback: function($$v) {
        _vm.$set(_vm.params, "unitType", $$v)
      },
      expression: "params.unitType"
    }
  }, _vm._l((_vm.dicDats['C019']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "independentLPSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择隶属关系"
    },
    model: {
      value: (_vm.params.independentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "independentLPSituation", $$v)
      },
      expression: "params.independentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C003']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 2) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("非独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "nonIndependentLPSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择隶属关系"
    },
    model: {
      value: (_vm.params.nonIndependentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "nonIndependentLPSituation", $$v)
      },
      expression: "params.nonIndependentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C004']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位地址"
    },
    model: {
      value: (_vm.params.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishAddr", $$v)
      },
      expression: "params.publishAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishPostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位邮编"
    },
    model: {
      value: (_vm.params.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPostalcode", $$v)
      },
      expression: "params.publishPostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位联系人"
    },
    model: {
      value: (_vm.params.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishLinkman", $$v)
      },
      expression: "params.publishLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位联系人座机号码"
    },
    model: {
      value: (_vm.params.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishTel", $$v)
      },
      expression: "params.publishTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishPhone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位联系人手机号码"
    },
    model: {
      value: (_vm.params.publishPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPhone", $$v)
      },
      expression: "params.publishPhone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位职工总数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.workers),
      callback: function($$v) {
        _vm.$set(_vm.params, "workers", $$v)
      },
      expression: "params.workers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务人员数：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessWorkers", $$v)
      },
      expression: "params.businessWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherWorkers", $$v)
      },
      expression: "params.otherWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("资产总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": _vm.layDasion == 2,
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.totalAssets),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalAssets", $$v)
      },
      expression: "params.totalAssets"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("负债总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": _vm.layDasion == 2,
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.totalLiabilities),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalLiabilities", $$v)
      },
      expression: "params.totalLiabilities"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n              注：请填写出版单位其他需要说明的相关信息，譬如注册资金为美元、法人变更在进行中等情况，如没有不填写\n            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("工商营业执照或事业法人证书信息（请按照营业执照或事业法人证书上的信息填写）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583c12e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/forEdit/table1.vue
// module id = 1745
// module chunks = 1